// extracted by mini-css-extract-plugin
export default {"MUI":"AddTooltip_MUI__Rni4A","Popover":"AddTooltip_Popover__vC1m4","Popover__input":"AddTooltip_Popover__input__mxmWR"};